import styled from 'styled-components';
import {palette} from '@/styles';
import {Flexbox} from './common';
import {interceptProps} from './utils';

export const GrayRoundedBox = styled.div`
  border-radius: 10px;
  padding: 16px;
  background-color: ${palette.gray100};
`;

export const DashRoundedBox = styled.div`
  border-radius: 10px;
  padding: 16px;
  border: dashed 1px ${palette.gray200};
`;

export const SimpleListBox = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: ${palette.gray400};
  ul {
    margin: 0;
    padding-left: 16px;
  }
  li {
    list-style-type: '• ';
  }
  li > ul {
    margin-bottom: 16px;
  }
`;

export const SimpleListBoxTitle = styled.div`
  color: ${palette.gray600};
  font-weight: 700;
`;

export const StepDots = styled(Flexbox)`
  gap: 6px;
`;

export const StepDot = styled('div').withConfig({
  shouldForwardProp: interceptProps(['active']),
})<{active?: boolean}>`
  width: 6px;
  height: 6px;
  border-radius: 100%;
  ${({active}) =>
    active
      ? `background-color: ${palette.primary400};`
      : `background-color: ${palette.gray150};`}
`;
